import React, { useState, createContext } from "react";
import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";

// Import components
import Benefit from "./pages/Benefit/Benefit";
import PlayStore from "./pages/PlayStore/PlayStore";
import Footer from "./pages/Footer/Footer";
import Features from "./pages/Features/Features";
import Product from "./pages/Product/Product";
import Banner from "./pages/Banner/Banner";
import Navbar from "./pages/Navbar/Navbar";
import Privacy from "./pages/Privacy/Privacy";
import ResponsivePricing from "./pages/ResponsivePricing/ResponsivePricing"; // ← Gunakan ResponsivePricing

// Import language provider
import { LanguageProvider } from "./components/Language/LanguageContext";

// Font imports
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/700.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import SupportandHelp from "./pages/FAQ/SupportandHelp";

// Create context
export const AppContentContext = createContext({
  ripple: true,
  inputStyle: "outlined",
  darkTheme: false,
  onInputStyleChange: (value: string) => {},
  onRippleChange: (value: boolean) => {},
});

function App() {
  const [topbarActive, setTopbarActive] = useState(false);
  const [ripple, setRipple] = useState(true);
  const [inputStyle, setInputStyle] = useState("outlined");
  const [darkTheme, setDarkTheme] = useState(false);

  const location = useLocation();

  const onTopbarMenuButtonClick = () => setTopbarActive(true);
  const onTopbarHide = () => setTopbarActive(false);
  const onInputStyleChange = (value: string) => setInputStyle(value);
  const onRippleChange = (value: boolean) => setRipple(value);

  return (
    <LanguageProvider>
      {/* Tampilkan navbar jika bukan di halaman /privacy */}
      {!["/privacy", "/support"].includes(location.pathname) && (
        <Navbar
          onTopbarMenuButtonClick={onTopbarMenuButtonClick}
          onTopbarHide={onTopbarHide}
        />
      )}

      <AppContentContext.Provider
        value={{
          ripple,
          inputStyle,
          darkTheme,
          onInputStyleChange,
          onRippleChange,
        }}
      >
        <div className="layout-content">
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Banner />
                  <Product />
                  <Features />
                  <Benefit />
                  <ResponsivePricing /> {/* ← Gunakan ResponsivePricing */}
                  <PlayStore />
                  <Footer />
                </>
              }
            />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/support" element={<SupportandHelp />} />
          </Routes>
        </div>
      </AppContentContext.Provider>
    </LanguageProvider>
  );
}

export default App;